export const NO_ACCOUNT_NAME = 'NO_ACCOUNT_NAME';
export const NO_COUNTRY = 'NO_COUNTRY';
export const NO_ACCOUNT_TEMPLATE_USER = 'NO_ACCOUNT_TEMPLATE_USER';
export const ACCOUNT_NAME_IS_ALREADY_USED = 'ACCOUNT_NAME_IS_ALREADY_USED';
export const ACCOUNT_MAME_CHECK_ERROR = 'ACCOUNT_MAME_CHECK_ERROR';
export const TEMPLATE_USERS_SUGGEST_ERROR = 'TEMPLATE_USERS_SUGGEST_ERROR';
export const PB_ID_SUGGEST_ERROR = 'PB_ID_SUGGEST_ERROR';

export const VALIDATION_ERRORS = {
    NO_ACCOUNT_NAME: 'The Account Name is a required field',
    ACCOUNT_NAME_IS_ALREADY_USED: 'The account with this name already exists',
    NO_COUNTRY: 'Country is a required field',
    NO_ACCOUNT_TEMPLATE_USER: 'The template user should be selected',
    ACCOUNT_MAME_CHECK_ERROR: 'Can\'t check account name. Service is temporary unavailable',
    TEMPLATE_USERS_SUGGEST_ERROR: 'Can\'t suggest users. Service is temporary unavailable',
    PB_ID_SUGGEST_ERROR: 'PB ID could not be found. Service is temporarily unavailable',
};
